/* eslint-disable @typescript-eslint/camelcase */

import {
  required,
  decimal,
  minValue,
  integer,
  maxLength
} from "vuelidate/lib/validators";

export default {
  report: {
    hcoIndAmount: { required, integer, minValue: minValue(0) },
    hcoGrpAmount: { required, integer, minValue: minValue(0) },
    hcoDonationTotal: { required, decimal, minValue: minValue(0) },
    hcoEventTotal: { required, decimal, minValue: minValue(0) },
    hcoSalaryTotal: { required, decimal, minValue: minValue(0) },

    hcpIndAmount: { required, integer, minValue: minValue(0) },
    hcpGrpAmount: { required, integer, minValue: minValue(0) },
    hcpEventTotal: { required, decimal, minValue: minValue(0) },
    hcpSalaryTotal: { required, decimal, minValue: minValue(0) },

    rndCost: { required, decimal, minValue: minValue(0) },

    q_1: { maxLength: maxLength(500) },
    q_2: { maxLength: maxLength(500) },
    q_3: { maxLength: maxLength(500) },
    q_4: { maxLength: maxLength(500) },
    organizationComments: { maxLength: maxLength(500) }
  }
};
